import { Link } from 'react-router-dom'
import { differenceInDays, parseISO, format } from 'date-fns'
import { useUpcomingVehicleReminders } from '../hooks/useVehicles'

const ReminderBadge = ({ dueDate }) => {
  if (!dueDate) return null
  const days = differenceInDays(parseISO(dueDate), new Date())
  if (days < 0) return <span className="text-xs font-semibold px-2 py-0.5 rounded-full bg-rose-100 text-rose-600">Overdue</span>
  if (days <= 7) return <span className="text-xs font-semibold px-2 py-0.5 rounded-full bg-amber-100 text-amber-700">{days}d</span>
  return <span className="text-xs text-text-muted">{format(parseISO(dueDate), 'MMM d')}</span>
}

export const VehicleRemindersWidget = () => {
  const { data: reminders = [], isLoading } = useUpcomingVehicleReminders(30)

  if (isLoading || reminders.length === 0) return null

  const top = reminders.slice(0, 4)

  return (
    <div className="mb-4">
      <div className="flex items-center justify-between mb-2">
        <h2 className="text-xs font-semibold text-text-muted uppercase tracking-wider">Vehicle Reminders</h2>
        <Link to="/vehicles" className="text-xs text-primary font-medium">View all</Link>
      </div>
      <div className="bg-surface rounded-base shadow-card overflow-hidden">
        {top.map((r, i) => (
          <Link
            key={r.id}
            to="/vehicles"
            className={`flex items-center justify-between px-4 py-3 hover:bg-background transition-colors ${i < top.length - 1 ? 'border-b border-border' : ''}`}
          >
            <div className="min-w-0">
              <p className="text-sm font-semibold text-text-primary truncate">{r.reminder_name}</p>
              <p className="text-xs text-text-muted truncate">{r.vehicle_name}</p>
            </div>
            <ReminderBadge dueDate={r.due_date} />
          </Link>
        ))}
      </div>
    </div>
  )
}
